export default "assets/images/icons/logo-secondary-567a94dc.svg";